import Grid from '@material-ui/core/Grid'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import moment from 'moment'
import React from 'react'

export default (props) => {
  const { reservations, reservation, quantiteMaxService } = props
  return (
    <Grid container alignContent={'flex-end'}>
      {
        reservation.date_reservation && reservation.produit_id && reservation.service_id &&
        <table style={{ width: '100%', borderRadius: 5, border: '1px solid black' }}>
          <thead>
            <tr style={{ background: '#FFFFFF' }}>
              <th colSpan="1"
                onClick={props.onClick('jour', reservations)}
                style={{
                  cursor: 'pointer', color: 'blue', textDecoration: 'underline'
                }}
                rowSpan={2}>
                {moment(reservation.date_reservation, 'YYYY-MM-DD').format('dddd DD MMMM YYYY')}
                <br />
                {(Data.get(Constants.module.RESTAURANT, Constants.donnee.produit, { id: reservation.produit_id }) || {}).libelle + ' / ' + (Data.get(Constants.module.RESTAURANT, Constants.donnee.service, { id: reservation.service_id }) || {}).libelle}
              </th>
              <th colSpan="7">Couvert(s)</th>
              <th colSpan="2">Total</th>
            </tr>
            <tr style={{ background: '#F0F0F0' }}>
              <td>1</td>
              <td>2</td>
              <td>3</td>
              <td>4</td>
              <td>5</td>
              <td>6</td>
              <td>+</td>
              <td>Table(s)</td>
              <td>Cvt(s)/Cvts Max</td>
            </tr>
          </thead>
          <tbody style={{ background: '#FFFFFF' }}>
            <tr>
                <td>Demande(s) de réservation</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite === 1).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite === 2).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite === 3).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite === 4).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite === 5).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite === 6).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0 && resa.quantite > 6).length}</td>
              <td>{reservations.filter(resa => resa.niveau === 0).length}</td>
              <td
                onClick={reservations.filter(resa => resa.niveau === 0).length > 0 && props.onClick('jour', reservations.filter(resa => resa.niveau === 0))}
                style={reservations.filter(resa => resa.niveau === 0).length > 0 && {
                  cursor: 'pointer', color: 'blue', textDecoration: 'underline'
                } || {}}>{reservations.filter(resa => resa.niveau === 0).reduce((memo, resa) => memo + resa.quantite, 0)}</td>
            </tr>
            <tr>
                <td>Réservation(s) confirmée(s)</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite === 1).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite === 2).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite === 3).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite === 4).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite === 5).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite === 6).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3 && resa.quantite > 6).length}</td>
              <td>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3).length}</td>
              <td
                onClick={reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3).length > 0 && props.onClick('jour', reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3))}
                style={reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3).length > 0 &&
                {
                  cursor: 'pointer', color: 'blue', textDecoration: 'underline'
                  } || {}}>{reservations.filter(resa => resa.niveau > 0 && resa.niveau <= 3).reduce((memo, resa) => memo + resa.quantite, 0)}{quantiteMaxService ? `/${quantiteMaxService}` : ''}</td>
            </tr>
          </tbody>
        </table>
      }
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/Component/CouvertGrid/index.js